//На вход передаем кол-во секунд
//0:00:0
export function formatSeconds_h_min_s(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = parseInt(seconds % 60);

  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  const formattedSeconds = secs < 10 ? '0' + secs : secs;

  if (hours > 0) {
    return hours + ':' + formattedMinutes + ':' + formattedSeconds;
  } else {
    return formattedMinutes + ':' + formattedSeconds;
  }
}
